<template>
  <b-container fluid>
    <b-row v-if="loaded">
        <b-col xs="12" sm="12" md="2" class="text-center m-auto">
            <b-img :src="`${ reportHeadData.reportHeadColumn[0].image }`" fluid alt="BD Image" style="width:75%;border-radius:50%;"></b-img>
        </b-col>
        <b-col xs="12" sm="12" md="6" class="text-center mt-2">
            <h4>{{ $t('production_store.govt_info') }}</h4>
            <h5 class="text-center text-dark">{{ reportHeadData.orgName }}</h5>
            <span class="text-center text-dark">{{ reportHeadData.heading }}</span><br>
            <span class="text-center text-dark">{{ reportHeadData.address }}</span><br>
            <h6><b>www.spst.gov.bd</b></h6><br>
        </b-col>
        <b-col xs="12" sm="12" md="2" class="text-right m-auto">
            <b-button class="btn-sm" variant="primary" @click="pdfExport">
                {{  $t('globalTrans.export_pdf') }}
            </b-button>
        </b-col>
    </b-row>
    <b-row>
        <b-col md="12">
            <b-row>
                <b-col class="text-center">
                    <H3><span style="background-color: black; color:white; font-weight: bold;">{{ $t('sales_distribution_admin.delivery_chalan') }}</span></H3>
                </b-col>
            </b-row>
            <b-row>
                <b-col class="text-left">
                  <span style="color: black; margin-left: 2px;">{{ $t('retailerManagement.chalan_no') }}: CH-{{ dataArray.delivery_id }}</span>
                </b-col>
            </b-row>
            <br>
            <!-- <b-row> -->
                <table class="report-table w-100">
                    <tr>
                        <td class="text-left ml-2" style="width: 50%">
                            <span style="color: black;">
                                <p>{{ $t('retailerManagement.demand_order_no') }}: {{ dataArray.order_id }}</p>
                                <p>{{ $t('retailerManagement.delivery_date') }}: <span style="border-bottom: 2px dotted #000;">{{ dataArray.delivery_date | dateFormat }}</span></p>
                            </span>
                        </td>
                        <td class="text-left" style="width: 50%">
                            <span style="color: black;">
                                <p>{{ $t('retailerManagement.recipient') }}: <span style="font-weight: 500">{{ getSalesCenterName(dataArray.sales_center_id) }}</span></p>
                                <p>{{ $t('retailerManagement.contact_no') }}. <span style="font-weight: 500">{{ dataArray.contact_no | mobileNumber }} </span></p>
                            </span>
                        </td>
                    </tr>
                </table>
                <br>
                <table class="report-table w-100">
                    <tr class="bg-light">
                        <th width="80px">{{ $t('globalTrans.sl_no') }}</th>
                        <th>{{ $t('sales_distribution_admin.pro_name') }}</th>
                        <th>{{ $t('sales_distribution_admin.unit') }}</th>
                        <th>{{ $t('sales_distribution_admin.quantity') }}</th>
                    </tr>
                    <tr v-for="(item, index) in dataArray.details" :key="index">
                        <td>{{ $n(index + 1) }}</td>
                        <td>{{ productNameById(item.product_id) }}</td>
                        <td>{{ unitNameById(item.unit_id) }}</td>
                        <td>{{ $n(item.quantity) }}</td>
                    </tr>
                </table>
                <br>
                <p style="color:black;">{{$t('retailerManagement.soft_gen_text')}}</p>
                <p style="color:black;">{{currentDateTime()}}</p>
            <!-- </b-row> -->
            <br>
        </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { mapGetters } from 'vuex'
import { productionServiceBaseUrl } from '@/config/api_config'
import ExportPdf from './export-chalan'
import ReportHeading from '@/Utils/report-head'
export default {
  props: ['id'],
  data () {
    return {
      dataArray: {
        sales_center_id: '',
        order_id: '',
        delivery_id: '',
        delivery_date: '',
        delivery_location: '',
        contact_no: '',
        comment: '',
        comment_bn: '',
        details: []
      },
      productList: {},
      unitLoad: false,
      sl: 0,
      loaded: false,
      loading: false
    }
  },
  created () {
    this.headerName()
    if (this.id) {
      const tmp = this.getDeliveryDetails()
      if (tmp.demand_main !== null) {
        this.dataArray.order_id = tmp.demand_main.demmand_id
      } else {
        this.dataArray.order_id = ''
      }
      this.dataArray.sales_center_id = tmp.sales_center_id
      this.dataArray.delivery_id = tmp.delivery_id
      this.dataArray.delivery_date = tmp.delivery_date
      this.dataArray.contact_no = tmp.contact_no
      this.dataArray.details = tmp.demand_details
      this.dataArray.delivery_location = tmp.delivery_location
    }
  },
  computed: {
    currentLocale () {
      return this.$i18n.locale
    },
    salesCenterList: function () {
      return this.$store.state.commonObj.officeList.filter(center => center.office_type_id === 2)
    },
    ...mapGetters({
      productCommonObj: 'ProductionService/commonObj'
    })
  },
  methods: {
    currentDateTime () {
        var options = {
            timeZone: 'Asia/Dhaka',
            year: 'numeric',
            month: 'numeric',
            day: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
            second: 'numeric'
        }

        var formatter = this.currentLocale === 'en' ? new Intl.DateTimeFormat(undefined, options) : new Intl.DateTimeFormat('bn-BD', options)
        var localDateTimeString = formatter.format(new Date())
        return localDateTimeString
    },
    async headerName () {
       const headdata = await ReportHeading.getReportHead(productionServiceBaseUrl, 'configuration/report-heading/detail', 6)
       this.reportHeadData = headdata
       this.loaded = true
    },
    getDeliveryDetails () {
      const tmpData = this.$store.state.list.find(item => item.id === parseInt(this.id))
      return tmpData
    },
    cancel () {
      this.$bvModal.hide('modal-2')
    },
    productNameById (id) {
      const product = this.productCommonObj.productList.find(
        (product) => product.value === id
      )
      if (this.$i18n.locale === 'bn') {
        return product.text_bn
      } else {
        return product.text_en
      }
    },
    unitNameById (id) {
      const unit = this.productCommonObj.productUnitList.find(
        (unit) => unit.value === id
      )
      if (this.$i18n.locale === 'bn') {
        return unit.text_bn
      } else {
        return unit.text_en
      }
    },
    pdfExport () {
      const reportTitle = this.$t('sales_distribution_admin.delivery_chalan')
      ExportPdf.exportPdfDetails(productionServiceBaseUrl, 'configuration/report-heading/detail', 6, reportTitle, this.dataArray, this)
    },
    getSalesCenterName (id) {
      const salesCenter = this.salesCenterList.find(
        (salescenter) => salescenter.value === id
      )
      if (this.$i18n.locale === 'bn') {
        return salesCenter.text_bn
      } else {
        return salesCenter.text_en
      }
    }
  }
}
</script>
<style>
.report-table tr,
th,
td {
    border: 1px solid #000;
    background-color: #fff;
    color: #000;
    font-weight: bold;
    padding-left: 5px;
    padding-right: 5px;
}
.border_less {
    border: 1px solid #fff;
    border-bottom: 1px solid #fff;
    background-color: #fff;
}
</style>
